import { render, staticRenderFns } from "./VotingConfirmDialog.vue?vue&type=template&id=9c81dac2&scoped=true"
import script from "./VotingConfirmDialog.vue?vue&type=script&lang=js"
export * from "./VotingConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./VotingConfirmDialog.vue?vue&type=style&index=0&id=9c81dac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c81dac2",
  null
  
)

export default component.exports